
export const state = () => ({
	direction: [],
	removeDirectionHandler: null
})

export const getters = {
	getDirectionList: (state) => state.direction,
	getRemoveDirectionHandler: (state) => state.removeDirectionHandler
}

export const mutations = {
	prepareRouteData (state) {
		// delete state.direction
		// if (!state.direction) return
		let routes, origin
		for(routes of state.direction) {
			for(origin of routes.origin) {
				// if (typeof origin.origin.lat === 'number') {
				// 	const val = parseFloat(origin.origin.lat)
				// 	origin.origin.lat = () => val
				// }
				// if (typeof origin.origin.lng === 'number') {
				// 	const val = parseFloat(origin.origin.lng)
				// 	origin.origin.lng = () => val
				// }
				origin.route = null
				// if (typeof origin.route.DRIVING.request.origin.location.lat === 'number') {
				// 	const val = parseFloat(origin.route.DRIVING.request.origin.location.lat)
				// 	origin.route.DRIVING.request.origin.location.lat = () => val
				// }
				// if (typeof origin.route.DRIVING.request.origin.location.lng === 'number') {
				// 	const val = parseFloat(origin.route.DRIVING.request.origin.location.lng)
				// 	origin.route.DRIVING.request.origin.location.lng = () => val
				// }
				// if (typeof origin.route.DRIVING.request.destination.location.lat === 'number') {
				// 	const val = parseFloat(origin.route.DRIVING.request.destination.location.lat)
				// 	origin.route.DRIVING.request.destination.location.lat = () => val
				// }
				// if (typeof origin.route.DRIVING.request.destination.location.lng === 'number') {
				// 	const val = parseFloat(origin.route.DRIVING.request.destination.location.lng)
				// 	origin.route.DRIVING.request.destination.location.lng = () => val
				// }
				// if (typeof origin.route.TRANSIT.request.origin.location.lat === 'number') {
				// 	const val = parseFloat(origin.route.TRANSIT.request.origin.location.lat)
				// 	origin.route.TRANSIT.request.origin.location.lat = () => val
				// }
				// if (typeof origin.route.TRANSIT.request.origin.location.lng === 'number') {
				// 	const val = parseFloat(origin.route.TRANSIT.request.origin.location.lng)
				// 	origin.route.TRANSIT.request.origin.location.lng = () => val
				// }
				// if (typeof origin.route.TRANSIT.request.destination.location.lat === 'number') {
				// 	const val = parseFloat(origin.route.TRANSIT.request.destination.location.lat)
				// 	origin.route.TRANSIT.request.destination.location.lat = () => val
				// }
				// if (typeof origin.route.TRANSIT.request.destination.location.lng === 'number') {
				// 	const val = parseFloat(origin.route.TRANSIT.request.destination.location.lng)
				// 	origin.route.TRANSIT.request.destination.location.lng = () => val
				// }
			}
		}
	},

	addDirection (state, { origin, destination, route, travelMode }) {
		let direction = state.direction.find(d => d.destination.place_id === destination.place_id)
		if (direction) {
			let from = direction.origin.find(o => {
				if (o && o.origin && origin) {
					let lat1 = (typeof o.origin.lat === 'number' ? o.origin.lat : o.origin.lat())
					let lat2 = (typeof origin.lat === 'number' ? origin.lat : origin.lat())
					let lng1 = (typeof o.origin.lng === 'number' ? o.origin.lng : o.origin.lng())
					let lng2 = (typeof origin.lng === 'number' ? origin.lng : origin.lng())
					if (lat1 === lat2 && lng1 === lng2) {
						return true
					}
				}
				return false
			})
			if (from) {
				if (!from.route) {
					from.route = {}
				}
				from.route[travelMode] = route
			} else {
				let tmpRoute = {}
				tmpRoute[travelMode] = route
				direction.origin.push({
					origin,
					route: tmpRoute
				})
			}
		} else {
			let tmpRoute = {}
			tmpRoute[travelMode] = route
			state.direction.push({
				destination,
				origin: [{
					origin,
					route: tmpRoute
				}]
			})
		}
	},

	removeDirection (state, direction) {
		for(let i=0; i<state.direction.length; ++i) {
			if(state.direction[i].destination === direction.destination) {
				let removed = state.direction.splice(i, 1)
				if(typeof state.removeDirectionHandler === 'function') {
					state.removeDirectionHandler(removed[0])
				}
				break
			}
		}
	},
	onRemoveDirection (state, handler) {
		state.removeDirectionHandler = handler
	}
}

export const actions = {
	prepareRouteData ({ commit }) {
		commit('prepareRouteData')
	},

	addDirection ({ commit }, { origin, destination, route, travelMode }) {
		commit('addDirection', { origin, destination, route, travelMode })
	},

	removeDirection ({commit}, direction) {
		commit('removeDirection', direction)
	},
	onRemoveDirection ({commit}, handler) {
		if (handler) {
			commit('onRemoveDirection', handler)
		}
	}
}
